const listOfWords = [
  { word: "fois", gender: "f" },
  { word: "madame", gender: "f" },
  { word: "paix", gender: "f" },
  { word: "voix", gender: "f" },
  { word: "affaire", gender: "f" },
  { word: "année", gender: "f" },
  { word: "arme", gender: "f" },
  { word: "armée", gender: "f" },
  { word: "attention", gender: "f" },
  { word: "balle", gender: "f" },
  { word: "boîte", gender: "f" },
  { word: "bouche", gender: "f" },
  { word: "carte", gender: "f" },
  { word: "cause", gender: "f" },
  { word: "chambre", gender: "f" },
  { word: "chance", gender: "f" },
  { word: "chose", gender: "f" },
  { word: "classe", gender: "f" },
  { word: "confiance", gender: "f" },
  { word: "couleur", gender: "f" },
  { word: "cour", gender: "f" },
  { word: "cuisine", gender: "f" },
  { word: "dame", gender: "f" },
  { word: "dent", gender: "f" },
  { word: "droite", gender: "f" },
  { word: "école", gender: "f" },
  { word: "église", gender: "f" },
  { word: "envie", gender: "f" },
  { word: "épaule", gender: "f" },
  { word: "époque", gender: "f" },
  { word: "équipe", gender: "f" },
  { word: "erreur", gender: "f" },
  { word: "espèce", gender: "f" },
  { word: "face", gender: "f" },
  { word: "façon", gender: "f" },
  { word: "faim", gender: "f" },
  { word: "famille", gender: "f" },
  { word: "faute", gender: "f" },
  { word: "femme", gender: "f" },
  { word: "fenêtre", gender: "f" },
  { word: "fête", gender: "f" },
  { word: "fille", gender: "f" },
  { word: "fleur", gender: "f" },
  { word: "force", gender: "f" },
  { word: "forme", gender: "f" },
  { word: "guerre", gender: "f" },
  { word: "gueule", gender: "f" },
  { word: "habitude", gender: "f" },
  { word: "heure", gender: "f" },
  { word: "histoire", gender: "f" },
  { word: "idée", gender: "f" },
  { word: "image", gender: "f" },
  { word: "impression", gender: "f" },
  { word: "jambe", gender: "f" },
  { word: "joie", gender: "f" },
  { word: "journée", gender: "f" },
  { word: "langue", gender: "f" },
  { word: "lettre", gender: "f" },
  { word: "lèvre", gender: "f" },
  { word: "ligne", gender: "f" },
  { word: "lumière", gender: "f" },
  { word: "main", gender: "f" },
  { word: "maison", gender: "f" },
  { word: "maman", gender: "f" },
  { word: "manière", gender: "f" },
  { word: "marche", gender: "f" },
  { word: "merde", gender: "f" },
  { word: "mère", gender: "f" },
  { word: "minute", gender: "f" },
  { word: "musique", gender: "f" },
  { word: "nuit", gender: "f" },
  { word: "odeur", gender: "f" },
  { word: "oreille", gender: "f" },
  { word: "parole", gender: "f" },
  { word: "partie", gender: "f" },
  { word: "peau", gender: "f" },
  { word: "peine", gender: "f" },
  { word: "pensée", gender: "f" },
  { word: "personne", gender: "f" },
  { word: "peur", gender: "f" },
  { word: "photo", gender: "f" },
  { word: "pièce", gender: "f" },
  { word: "pierre", gender: "f" },
  { word: "place", gender: "f" },
  { word: "police", gender: "f" },
  { word: "porte", gender: "f" },
  { word: "présence", gender: "f" },
  { word: "prison", gender: "f" },
  { word: "putain", gender: "f" },
  { word: "question", gender: "f" },
  { word: "raison", gender: "f" },
  { word: "réponse", gender: "f" },
  { word: "robe", gender: "f" },
  { word: "route", gender: "f" },
  { word: "salle", gender: "f" },
  { word: "scène", gender: "f" },
  { word: "seconde", gender: "f" },
  { word: "sécurité", gender: "f" },
  { word: "semaine", gender: "f" },
  { word: "situation", gender: "f" },
  { word: "soeur", gender: "f" },
  { word: "soirée", gender: "f" },
  { word: "sorte", gender: "f" },
  { word: "suite", gender: "f" },
  { word: "table", gender: "f" },
  { word: "terre", gender: "f" },
  { word: "tête", gender: "f" },
  { word: "vérité", gender: "f" },
  { word: "ville", gender: "f" },
  { word: "voiture", gender: "f" },
  { word: "avis", gender: "m" },
  { word: "bois", gender: "m" },
  { word: "bras", gender: "m" },
  { word: "choix", gender: "m" },
  { word: "corps", gender: "m" },
  { word: "cours", gender: "m" },
  { word: "gars", gender: "m" },
  { word: "mois", gender: "m" },
  { word: "pays", gender: "m" },
  { word: "prix", gender: "m" },
  { word: "propos", gender: "m" },
  { word: "sens", gender: "m" },
  { word: "temps", gender: "m" },
  { word: "travers", gender: "m" },
  { word: "vieux", gender: "m" },
  { word: "accord", gender: "m" },
  { word: "agent", gender: "m" },
  { word: "amour", gender: "m" },
  { word: "appel", gender: "m" },
  { word: "arbre", gender: "m" },
  { word: "argent", gender: "m" },
  { word: "avenir", gender: "m" },
  { word: "avion", gender: "m" },
  { word: "bateau", gender: "m" },
  { word: "bébé", gender: "m" },
  { word: "besoin", gender: "m" },
  { word: "bonheur", gender: "m" },
  { word: "bonjour", gender: "m" },
  { word: "bord", gender: "m" },
  { word: "boulot", gender: "m" },
  { word: "bout", gender: "m" },
  { word: "bruit", gender: "m" },
  { word: "bureau", gender: "m" },
  { word: "café", gender: "m" },
  { word: "camp", gender: "m" },
  { word: "capitaine", gender: "m" },
  { word: "chat", gender: "m" },
  { word: "chemin", gender: "m" },
  { word: "chéri", gender: "m" },
  { word: "cheval", gender: "m" },
  { word: "cheveu", gender: "m" },
  { word: "chien", gender: "m" },
  { word: "ciel", gender: "m" },
  { word: "client", gender: "m" },
  { word: "cœur", gender: "m" },
  { word: "coin", gender: "m" },
  { word: "colonel", gender: "m" },
  { word: "compte", gender: "m" },
  { word: "copain", gender: "m" },
  { word: "côté", gender: "m" },
  { word: "coup", gender: "m" },
  { word: "courant", gender: "m" },
  { word: "début", gender: "m" },
  { word: "départ", gender: "m" },
  { word: "dieu", gender: "m" },
  { word: "docteur", gender: "m" },
  { word: "doigt", gender: "m" },
  { word: "dollar", gender: "m" },
  { word: "doute", gender: "m" },
  { word: "droit", gender: "m" },
  { word: "effet", gender: "m" },
  { word: "endroit", gender: "m" },
  { word: "ennemi", gender: "m" },
  { word: "escalier", gender: "m" },
  { word: "esprit", gender: "m" },
  { word: "état", gender: "m" },
  { word: "être", gender: "m" },
  { word: "exemple", gender: "m" },
  { word: "fait", gender: "m" },
  { word: "film", gender: "m" },
  { word: "flic", gender: "m" },
  { word: "fond", gender: "m" },
  { word: "français", gender: "m" },
  { word: "frère", gender: "m" },
  { word: "front", gender: "m" },
  { word: "garçon", gender: "m" },
  { word: "général", gender: "m" },
  { word: "genre", gender: "m" },
  { word: "goût", gender: "m" },
  { word: "gouvernement", gender: "m" },
  { word: "grand", gender: "m" },
  { word: "groupe", gender: "m" },
  { word: "haut", gender: "m" },
  { word: "homme", gender: "m" },
  { word: "honneur", gender: "m" },
  { word: "hôtel", gender: "m" },
  { word: "instant", gender: "m" },
  { word: "intérêt", gender: "m" },
  { word: "intérieur", gender: "m" },
  { word: "jardin", gender: "m" },
  { word: "jour", gender: "m" },
  { word: "journal", gender: "m" },
  { word: "lieu", gender: "m" },
  { word: "long", gender: "m" },
  { word: "maître", gender: "m" },
  { word: "mari", gender: "m" },
  { word: "mariage", gender: "m" },
  { word: "matin", gender: "m" },
  { word: "médecin", gender: "m" },
  { word: "mètre", gender: "m" },
  { word: "milieu", gender: "m" },
  { word: "million", gender: "m" },
  { word: "moment", gender: "m" },
  { word: "monde", gender: "m" },
  { word: "monsieur", gender: "m" },
  { word: "mouvement", gender: "m" },
  { word: "moyen", gender: "m" },
  { word: "noir", gender: "m" },
  { word: "nouveau", gender: "m" },
  { word: "numéro", gender: "m" },
  { word: "oeil", gender: "m" },
  { word: "oiseau", gender: "m" },
  { word: "oncle", gender: "m" },
  { word: "ordre", gender: "m" },
  { word: "papa", gender: "m" },
  { word: "papier", gender: "m" },
  { word: "parent", gender: "m" },
  { word: "passage", gender: "m" },
  { word: "passé", gender: "m" },
  { word: "patron", gender: "m" },
  { word: "père", gender: "m" },
  { word: "petit", gender: "m" },
  { word: "peuple", gender: "m" },
  { word: "pied", gender: "m" },
  { word: "plaisir", gender: "m" },
  { word: "plan", gender: "m" },
  { word: "point", gender: "m" },
  { word: "pouvoir", gender: "m" },
  { word: "premier", gender: "m" },
  { word: "présent", gender: "m" },
  { word: "président", gender: "m" },
  { word: "prince", gender: "m" },
  { word: "problème", gender: "m" },
  { word: "quartier", gender: "m" },
  { word: "rapport", gender: "m" },
  { word: "regard", gender: "m" },
  { word: "reste", gender: "m" },
  { word: "retard", gender: "m" },
  { word: "retour", gender: "m" },
  { word: "rêve", gender: "m" },
  { word: "revoir", gender: "m" },
  { word: "salut", gender: "m" },
  { word: "sang", gender: "m" },
  { word: "secret", gender: "m" },
  { word: "seigneur", gender: "m" },
  { word: "sentiment", gender: "m" },
  { word: "service", gender: "m" },
  { word: "seul", gender: "m" },
  { word: "siècle", gender: "m" },
  { word: "signe", gender: "m" },
  { word: "silence", gender: "m" },
  { word: "soir", gender: "m" },
  { word: "soldat", gender: "m" },
  { word: "soleil", gender: "m" },
  { word: "sourire", gender: "m" },
  { word: "souvenir", gender: "m" },
  { word: "sujet", gender: "m" },
  { word: "téléphone", gender: "m" },
  { word: "tout", gender: "m" },
  { word: "train", gender: "m" },
  { word: "travail", gender: "m" },
  { word: "trou", gender: "m" },
  { word: "truc", gender: "m" },
  { word: "type", gender: "m" },
  { word: "vent", gender: "m" },
  { word: "ventre", gender: "m" },
  { word: "verre", gender: "m" },
  { word: "village", gender: "m" },
  { word: "visage", gender: "m" },
  { word: "voyage", gender: "m" },
];
export default listOfWords;
